<template>
  <div class="console-wrapper">
    <div v-if="consoleObjects && consoleObjects.length">
      <div v-for="(item, index) in consoleObjects" :key="item._id" class="object-wrapper" :class="{ current: index === currentConsoleObjectIndex, past: index <= currentConsoleObjectIndex, future: index > currentConsoleObjectIndex }">
        <div class="type-wrapper" v-if="item.type === 'console'">
          <div class="type">Console</div>
          <div class="object" v-for="(arg, argIndex) in item.arguments" :key="argIndex">
            <div v-if="arg.type === 'string'">
              {{ arg.content }}
            </div>
            <div v-if="arg.type === 'object'">
              <JSONDisplay :obj="arg.content" />
            </div>
          </div>
        </div>
        <div class="type-wrapper" v-if="item.type === 'nav'">
          <div class="type">Nav</div>
          <div class="object">{{ item.window.location.href }}</div>
        </div>
        <div class="type-wrapper" v-if="item.type === 'error'">
          <div class="type">Error</div>
          <div class="object">{{ item.stack }}</div>
        </div>
        <div class="type-wrapper" v-if="item.type === 'network'">
          <div class="type">Network</div>
          <div class="object">{{ item.method }} {{ item.url }}</div>
        </div>
      </div>
    </div>
    <div v-else class="empty-state">
      <h2>No console information</h2>
      <p>
        It looks like no console information was captured for this recording.
        Cappture can gather console logs, network requests, runtime errors, DOM snapshots, and page navigations.
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import JSONDisplay from './JSONDisplay.vue';

export default {
  name: 'RecordingConsole',
  components: {
    JSONDisplay,
  },
  computed: {
    ...mapGetters({
      consoleObjects: 'recordings/consoleObjects',
      currentConsoleObjectIndex: 'recordings/currentConsoleObjectIndex',
      videoTimeInMS: 'recordings/videoTimeInMS',
    }),
  },
  updated() {
    // Update scroll position of console-wrapper
    const currentConsoleObject = this.$el.querySelector('.current');
    if (!currentConsoleObject) {
      this.$el.scrollTop = 0;
    } else {
      this.$el.scrollTop = currentConsoleObject.offsetTop - (this.$el.offsetHeight / 2);
    }
  },
};
</script>

<style lang="scss" scoped>
.console-wrapper {
  align-self: center;
  width: 1024px;
  height: 300px;
  overflow-y: scroll;
  position: relative;
  .object-wrapper {
    // &.past {

    // }
    &.future {
      color: grey;
    }
    .type-wrapper {
      display: flex;
      .type {
        width: 100px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RecordingConsole.vue